export default ({ id }) => {
  return { id };
};
